var map = {
	"./decidim/avatar-multiuser.png": 74292,
	"./decidim/brands/facebook.svg": 35578,
	"./decidim/brands/google.svg": 2651,
	"./decidim/brands/twitter-x.svg": 84200,
	"./decidim/cc-badge.png": 54230,
	"./decidim/decidim-logo.svg": 80278,
	"./decidim/default-avatar.svg": 21682,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 34934,
	"./decidim/icons.svg": 59781,
	"./decidim/pattern.png": 44402,
	"./decidim/placeholder-card-g.svg": 55967,
	"./decidim/placeholder-card-l.svg": 59908,
	"./decidim/placeholder.jpg": 3771,
	"./decidim/remixicon.symbol.svg": 11155,
	"./decidim/vendor/social-share-button/douban.svg": 96450,
	"./decidim/vendor/social-share-button/email.svg": 44031,
	"./decidim/vendor/social-share-button/facebook.svg": 90401,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 50707,
	"./decidim/vendor/social-share-button/hacker_news.svg": 56179,
	"./decidim/vendor/social-share-button/linkedin.svg": 62575,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 51016,
	"./decidim/vendor/social-share-button/pinterest.svg": 35697,
	"./decidim/vendor/social-share-button/reddit.svg": 82081,
	"./decidim/vendor/social-share-button/telegram.svg": 57432,
	"./decidim/vendor/social-share-button/tumblr.svg": 29775,
	"./decidim/vendor/social-share-button/twitter.svg": 73710,
	"./decidim/vendor/social-share-button/vkontakte.svg": 39312,
	"./decidim/vendor/social-share-button/wechat.svg": 70619,
	"./decidim/vendor/social-share-button/whatsapp.svg": 71219,
	"./decidim/vendor/social-share-button/x.svg": 16055,
	"./decidim/vendor/social-share-button/xing.svg": 90721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99133;